import { render, staticRenderFns } from "./viewExpense.vue?vue&type=template&id=087b8531&scoped=true&"
import script from "./viewExpense.vue?vue&type=script&lang=js&"
export * from "./viewExpense.vue?vue&type=script&lang=js&"
import style0 from "./viewExpense.vue?vue&type=style&index=0&id=087b8531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b8531",
  null
  
)

export default component.exports